/**
 * @file includeSubscriptionStatus.ts
 * @description 是否包含订阅功能
 */

// 订阅状态枚举
export enum SUBSCRIPTION_STATUS {
  UNKNOWN = 0, // 未知
  INCLUDED = 1, // 含订阅
  NOT_INCLUDED = 2, // 不含订阅
}

// 订阅状态项类型定义
export type SubscriptionStatusItem = {
  value: SUBSCRIPTION_STATUS
  label: string
  classTagName: string
}

// 订阅状态数据
export const subscriptionStatusData: SubscriptionStatusItem[] = [
  // {
  //   value: SUBSCRIPTION_STATUS.UNKNOWN,
  //   label: '未知',
  //   classTagName: 'nomal-tagbgc-grey',
  // },
  {
    value: SUBSCRIPTION_STATUS.INCLUDED,
    label: '含订阅',
    classTagName: 'nomal-tagbgc-green',
  },
  {
    value: SUBSCRIPTION_STATUS.NOT_INCLUDED,
    label: '不含订阅',
    classTagName: 'nomal-tagbgc-grey',
  },
]

/**
 * 获取订阅状态的属性值
 * @param {SUBSCRIPTION_STATUS} status - 订阅状态值
 * @param {keyof SubscriptionStatusItem} key - 要获取的属性键名
 * @returns {SubscriptionStatusItem[keyof SubscriptionStatusItem]} 返回对应的属性值，如果未找到则返回空字符串
 * @example
 * // 获取状态为"包含"的标签文本
 * getSubscriptionProperty(SUBSCRIPTION_STATUS.INCLUDED, 'label') // 返回 "包含"
 * // 获取状态为"不包含"的样式类名
 * getSubscriptionProperty(SUBSCRIPTION_STATUS.NOT_INCLUDED, 'classTagName') // 返回 "nomal-tagbgc-gray"
 */
export function getSubscriptionProperty<K extends keyof SubscriptionStatusItem>(
  status: SUBSCRIPTION_STATUS,
  key: K,
): SubscriptionStatusItem[K] | '' {
  return subscriptionStatusData.find((item) => item.value === status)?.[key] ?? ''
}
